import { render } from "./eb-card.vue?vue&type=template&id=37f23334"
import script from "./eb-card.vue?vue&type=script&lang=ts"
export * from "./eb-card.vue?vue&type=script&lang=ts"
script.render = render

export default script